export const TYPE = {
    SHOW_MODAL_COMMERCIAL: 'SHOW_MODAL_COMMERCIAL',
    SET_OFFER_SELECTOR: 'OFFER_SELECTOR',
    SET_PAYMENT_LINK: 'SET_PAYMENT_LINK',
    SET_PARAM_PAYMENT_IS_ACTIVE: 'SET_PARAM_PAYMENT_IS_ACTIVE',
  };